module.exports = __webpack_public_path__ + "static/media/roulette_casino_end.bc476913.mp3";